import React from "react";
import "./css/Director.css"

const Director = () => {
  return (
    <>
      <div className="director-sid">
        <div className="director-sid-row">
          <div className="director-sid-col">
            <img src="./img/di.jpeg" />
            <h4>Mr. Dharmendra Nagar</h4>
          </div>
          <div className="director-sid-col">
            <h2>Director Message</h2>
            <h6>
              Dear Parent & Students, It gives me great pleasure to welcome you
              to Education Valley School Bhopal. The school is committed to inculcating in all
              our students; strong ethical valued of integrity, respect and
              discipline as well as clarity in thought and decision-making
              ability, as a life-long process. In order to achieve all this, We
              follow a rigorous programme that is based upon the best
              educational practices, highly progressive and recognized
              world-wide and one that creates conditions for students to
              maximize their potential at an internationally competitive level.
              Our state-of-the-art infrastructure, coupled with highly qualified
              and well-trained teachers, ensures that the students at NBVHSS
              should be able to gain an enriching experience. Furthermore, it
              has been one of my quests in life to make high quality education
              available; accessible through the latest educational technology.
              The mission of the school is to develop responsible global
              citizens and leaders through academic excellence, We will be the
              foundation for a new generation of leaders and innovators, who
              will continue to pave the way for a better and brighter future for
              our world. The greatest strength of Education Valley School Bhopal 
              is the high quality
              programmes and transparency in its system. We are fortunate to
              have a school community which includes talented teachers and
              supportive parents who work together to make great students, an ideal
              place for our motivated students to learn and grow. We are always
              open to new ideas, inquiries and feedback, from all. Over the past
              18 years, EVSB has lived up to its mission statement and
              established itself as one of the top educational institutions for
              students and parents in Bhopal. I welcome you to be a part of
              EVSB family!
            </h6>
          </div>
        </div>
      </div>
    </>
  );
};

export default Director;
